import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';

import { DirectAuthor } from '../../pieces/DirectAuthor';
import DirectAvatar from '../../pieces/DirectAvatar';
import { Timestamp } from '../../pieces/Timestamp';

export function Header({ ava, userId, name, createdAt }) {
  return (
    <div className="not-prose flex flex-row items-center justify-between">
      <div className="flex h-10 items-center gap-2">
        <div className="grid h-9 w-9 place-items-center overflow-hidden rounded-full">
          <DirectAvatar source={ava} altcap={name} />
        </div>
        <div className="flex flex-col">
          <div className="text-clip text-sm line-clamp-1 hover:underline sm:text-base">
            <DirectAuthor id={userId} name={name} />
          </div>
          <div className="text-clip text-xs opacity-90 line-clamp-1 hover:underline group-hover:opacity-100">
            <Timestamp createdAt={createdAt} />
          </div>
        </div>
      </div>
      <button className="relative inline-block py-2 opacity-30">
        <Icon icon="ph:dots-three-outline-vertical-fill" />
      </button>
    </div>
  );
}

Header.propTypes = {
  ava: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
};
